import '@babel/polyfill';
import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/firebase/';
import VueFire from 'vuefire';
import firebase from 'firebase';

import { pushProperties } from '@/global.js'

import VueAnalytics from 'vue-analytics' // Google Analytics

// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-151323970-1'
})

Vue.use(VueFire)

Vue.config.productionTip = false;

const app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
if (window.Cypress) {
    window.app = app;
}

// let app;
// firebase.auth().onAuthStateChanged(async user => {
//   if (!app) {
//     if (user) {
//       await store.dispatch(AUTH_SUCCESS, utils.mapUser(user));
//     } else {
//       await store.dispatch(AUTH_LOGOUT);
//     }
//     app = new Vue({
//       router,
//       store,
//       i18n,
//       render: h => h(App)
//     }).$mount("#app");
//   }
// });


window.addEventListener('load', () => {
if (!('serviceWorker' in navigator)) {
    // service workers not supported 
    return
}

navigator.serviceWorker.register('/sw.js').then(
    () => {
    // registered!
    }
)
})

// Configuração do push notification #push#
const messaging = firebase.messaging();

messaging.usePublicVapidKey("BK8oBS8GpIv7kNAknwhqtshMPIcsfdBPEErkzsMigP3rpJl4vA7YLgWCRnJg-49rRRuQpxCu5df5O4XUBxRUSfE"); // 1. Generate a new key pair. Configuração da Web > Certificados push da Web > Par de chaves

// Request Permission of Notifications
messaging.requestPermission().then(() => {
  console.log('Notification permission granted.');

  // Get Token
  messaging.getToken().then((token) => {
    //console.log("Meu token FMC para push notification = "+token)
    sessionStorage.setItem('tokenFMC', token);
  })
}).catch((err) => {
  console.log('Unable to get permission to notify.', err);
});

/*
Vue.prototype.$messaging = firebase.messaging()

navigator.serviceWorker.register('/firebase-messaging-sw.js')
  .then((registration) => {
    Vue.prototype.$messaging.useServiceWorker(registration)
  }).catch(err => {
    console.log(err)
  })*/

  // const messaging = firebase.messaging();

  // messaging
  // .requestPermission()
  // .then(() => firebase.messaging().getToken())
  // .then((token) => {
  //     console.log(token) // Receiver Token to use in the notification
  // })
  // .catch(function(err) {
  //     console.log("Unable to get permission to notify.", err);
  // });


  // Mensagem quando o aplicativo estiver aberto/foreground - https://firebase.google.com/docs/cloud-messaging/js/receive
  messaging.onMessage(function(payload) {
    
    console.log("Message received. ", payload);
    //alert("Message received. ", payload);
    pushProperties.exibirPush = true;
    pushProperties.title = payload.notification.title;
    pushProperties.body = payload.notification.body;
  // ...
  });



  
//   // Get Instance ID token. Initially this makes a network call, once retrieved
// // subsequent calls to getToken will return from cache.
// messaging.getToken().then(function(currentToken) {
//     console.log('Token='+currentToken);
//   }).catch(function(err) {
//     console.log('An error occurred while retrieving token. ', err);
//     //showToken('Error retrieving Instance ID token. ', err);
//   });

//   // Callback fired if Instance ID token is updated.
// messaging.onTokenRefresh(function() {
//     messaging.getToken().then(function(refreshedToken) {
//       console.log('Token refreshed.' + refreshedToken);
//       // Indicate that the new Instance ID token has not yet been sent to the
//       // app server.
      
//       // ...
//     }).catch(function(err) {
//       console.log('Unable to retrieve refreshed token ', err);
//     });
//   });
  
  // messaging.onMessage(function(payload) {
  //   console.log('Message received. ', payload);
  //   alert(payload);
  //   // ...
  // });




  // function getAccessToken() {
  //   return new Promise(function(resolve, reject) {
  //       var key = require('/service-account.json');
        
  //       var jwtClient = new google.auth.JWT(
  //       key.client_email,
  //       null,
  //       key.private_key,
  //       SCOPES,
  //       null
  //       );
  //       jwtClient.authorize(function(err, tokens) {
  //       if (err) {
  //           reject(err);
  //           return;
  //       }
  //       resolve(tokens.access_token);
  //       });
  //   });
  // }
  
  // console.log("Bearer = "+getAccessToken());





// // #### VIMEO
// // Carregue o SDK
// let Vimeo = require('vimeo').Vimeo;
// let client = new Vimeo("e5b5feb0c3fe2b13da1fab5757e96a4e6df9436f", "M2EtX74RrfAGdL16I2g7DJyUjWJ/sRKYKheSmg0vIrfvgVc/ew/NcpO2IIrdhRL9jVvp7MgQwh3xHT04m4eJNicNOPYH/6fGdSTvARZB7v3bRd+K/nUDZPJqDCHpCaI4", "9f90073db9dcd6f66a5aa2a7c9926fc1");

// // Carregar o vídeo
// let file_name = "C:/Users/rafael.silvestre/Documents/Clientes/Pessoal/IN-Class/video/apresentacao-app_AME/composicao-teste.mp4"//"{path to a video on the file system}"
// client.upload(
//   file_name,
//   {
//     'name': 'Untitled',
//     'description': 'The description goes here.'
//   },
//   function (uri) {
//     console.log('Your video URI is: ' + uri);
//   },
//   function (bytes_uploaded, bytes_total) {
//     var percentage = (bytes_uploaded / bytes_total * 100).toFixed(2)
//     console.log(bytes_uploaded, bytes_total, percentage + '%')
//   },
//   function (error) {
//     console.log('Failed because: ' + error)
//   }
// )

// //Verifique o status da transcodificação
// client.request(uri + '?fields=transcode.status', function (error, body, status_code, headers) {
//   if (body.transcode.status === 'complete') {
//     console.log('Your video finished transcoding.')
//   } else if (body.transcode.status === 'in_progress') {
//     console.log('Your video is still transcoding.')
//   } else {
//     console.log('Your video encountered an error during transcoding.')
//   }
// })

// //Obtenha o link para o vídeo enviado
// client.request(uri + '?fields=link', function (error, body, statusCode, headers) {
//   if (error) {
//     console.log('There was an error making the request.')
//     console.log('Server reported: ' + error)
//     return
//   }

//   console.log('Your video link is: ' + body.link)
// })


// var inspect = require('eyespect').inspector();
// var request = require('request')
// var path = require('path')
// var fs = require('fs')
// var filePath = path.join(__dirname, '../public/uploads/foo.mp4')
// fs.stat(filePath, function(err, stats) {
//   if (err) {
//     inspect(err, 'error stating file')
//     return
//   }
//   var fileSize = stats.size
//   var url = 'https://126535.cloud.vimeo.com/upload?ticket_id=9d818e8bd066dfd54e53f1be2fa3f958'
//   var opts = {
//     url: url,
//     method: 'post',
//     headers: {
//       'Content-Length': fileSize,
//       'Content-Type': 'foo'
//   }
//   var r = request(opts)

//   // pipe the file on disk to vimeo
//   var readStream = fs.createReadStream(filePath)
//   readStream.pipe(r)
//   readStream.on('error', function (err) {
//     inspect(err, 'error uploading file')
//   })
//   readStream.on('end', function (err) {
//     inspect('file uploaded correctly')
//   })
// })